
<!-- ======= Featured Services Section ======= -->
<section id="featured-services" class="featured-services">
  <div class="container" data-aos="fade-up">

    <div class="text-center my-2 section-title">
      <h3 data-aos="fade-up" data-aos-delay="100">Become a Pro Trader with
        <span> HAWK </span>
      </h3>
      <br>

      <h6 class=" m-auto">
        Trade as a pro with HAWK. We will awake the Super Trader within you with proper guidance, education, Live market updates, financial news, and streaming services.
      </h6>

    </div>

    <div class="row">

      <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
          <div class="icon"><i class="bx bx-bulb"></i></div>
          <h4 class="title"> Learn </h4>
          <p class="description">We employ best people and invest in advanced and cutting-edge technologies to ensure that our students learn effectively and acquire the fundamental and technical skills for consistency in theirtrading.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
        <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
          <div class="icon"><i class="bx bx-transfer"></i></div>
          <h4 class="title"> Trade </h4>
          <p class="description">HAWK group of professional trainers focus on trader skill development and understanding, by using advanced proprietary technologies to boost trader’s ability to recall market patterns and to develop trading strategies that cater
            for a person’s unique personality and temperament.</p>
        </div>
      </div>

      <div class="col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
        <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
          <div class="icon"><i class="bx bx-dollar"></i></div>
          <h4 class="title"> Profit </h4>
          <p class="description">Our daily briefings are designed with most accurate financial data and analysis so you can Learn what’s happening in the world of investing in just 5 minutes. We select investing insights from the world’s top investing experts.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Featured Services Section -->
